import { inject } from '@angular/core';
import type { ResolveFn, Routes } from '@angular/router';

import type { PlansResponse, TopUpResponse } from '@core/services';
import { BillingService } from '@core/services';

const topUpsResolver: ResolveFn<TopUpResponse> = () => {
  const billingService = inject(BillingService);

  return billingService.getTopUps();
};

const plansResolver: ResolveFn<PlansResponse> = () => {
  const billingService = inject(BillingService);

  return billingService.getPlans();
};

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@features/home/home').then((m) => m.Home),
    title: 'EVRN — Control Over Machines',
  },
  {
    path: 'demo',
    loadComponent: () => import('@features/demo/demo').then((m) => m.Demo),
    title: 'EVRN — Demo',
  },
  {
    path: 'plans',
    loadComponent: () => import('@features/plans/plans').then((m) => m.Plans),
    title: 'EVRN — Plans',
    resolve: {
      plansData: plansResolver,
      topUpsData: topUpsResolver,
    },
  },
  {
    path: 'origin',
    loadComponent: () => import('@features/origin/origin').then((m) => m.Origin),
    title: 'EVRN — Origin',
  },
  {
    path: 'contact',
    loadComponent: () => import('@features/contact/contact').then((m) => m.Contact),
    title: 'EVRN — Contact',
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('@features/legals/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
    title: 'EVRN — Privacy Policy',
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('@features/legals/terms-and-conditions/terms-and-conditions').then(
        (m) => m.TermsAndConditions,
      ),
    title: 'EVRN — Terms and Conditions',
  },
  {
    path: 'cookie-policy',
    loadComponent: () =>
      import('@features/legals/cookie-policy/cookie-policy').then((m) => m.CookiePolicy),
    title: 'EVRN — Cookie Policy',
  },
  { path: '**', redirectTo: '' },
];
